import { ExModule } from "vuex";
import { State, Actions, Getters, Mutations, MenuType } from "./types";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state: State = {
  partnerUser: undefined,
  availableContracts: [],
  expiredContracts: [],
  loadingStatus: false,
  passwordReissue: {
    email: ""
  },
  passwordReset: {
    reset_password_token: "",
    password: "",
    password_confirmation: ""
  },
  scoutPlan: {
    scoutPlan: undefined,
    remainingTicketsCount: undefined,
    expirationAtMs: undefined,
    scoutTargetGraduateYears: []
  },
  savedSearchOptionCount: undefined,
  menuType: MenuType.MENU_DEFAULT
};

const userModule: ExModule<State, Actions, Getters, Mutations> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default userModule;
